/* eslint-disable */

/* This is auto generated code. Do not edit!!! */

import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: string; output: string; }
  AWSIPAddress: { input: string; output: string; }
  AWSJSON: { input: string; output: string; }
  AWSPhone: { input: string; output: string; }
  AWSTime: { input: string; output: string; }
  AWSTimestamp: { input: number; output: number; }
  AWSURL: { input: string; output: string; }
};

export const GraphQLCardExpiryStatus = {
  Expired: 'EXPIRED',
  ExpiringSoon: 'EXPIRING_SOON'
} as const;

export type GraphQLCardExpiryStatus = typeof GraphQLCardExpiryStatus[keyof typeof GraphQLCardExpiryStatus];
export type GraphQLCommitment = {
  _sys?: Maybe<GraphQLCommitmentSys>;
  amountDue?: Maybe<Scalars['Float']['output']>;
  canGiveGifts: Scalars['Boolean']['output'];
  canMakePayments: Scalars['Boolean']['output'];
  canWrite: Scalars['Boolean']['output'];
  commitmentType: GraphQLCommitmentType;
  creditRemaining?: Maybe<Scalars['Float']['output']>;
  dates: GraphQLCommitmentDates;
  dueThisMonthAmount?: Maybe<Scalars['Float']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  fund?: Maybe<GraphQLCommitmentFund>;
  globalId: Scalars['ID']['output'];
  hasCredit?: Maybe<Scalars['Boolean']['output']>;
  hasDueThisMonth?: Maybe<Scalars['Boolean']['output']>;
  hasMissedPayment?: Maybe<Scalars['Boolean']['output']>;
  internalId: Scalars['String']['output'];
  interventionId?: Maybe<Scalars['String']['output']>;
  isCorrespondent?: Maybe<Scalars['Boolean']['output']>;
  isRecurring: Scalars['Boolean']['output'];
  lastCorrespondenceDate?: Maybe<Scalars['String']['output']>;
  missedPaymentAmount?: Maybe<Scalars['Float']['output']>;
  participant?: Maybe<GraphQLCommitmentParticipant>;
  /** Next payment date in YYYY-MM-DD format (e.g., "2024-01-15") */
  paymentDateNext?: Maybe<Scalars['AWSDate']['output']>;
  paymentDatePending?: Maybe<Scalars['Boolean']['output']>;
  paymentFrequency?: Maybe<Scalars['String']['output']>;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  paymentPullDay?: Maybe<Scalars['Int']['output']>;
  rate: Scalars['Float']['output'];
  receiptorId?: Maybe<Scalars['String']['output']>;
  sourceCode?: Maybe<Scalars['String']['output']>;
  sponsorshipChangeState?: Maybe<GraphQLSponsorshipChangeState>;
  status: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type GraphQLCommitmentDates = {
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type GraphQLCommitmentFund = {
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
};

export type GraphQLCommitmentParticipant = {
  birthdate?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  globalId?: Maybe<Scalars['String']['output']>;
  localId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
};

export type GraphQLCommitmentSys = {
  billingType: Scalars['String']['output'];
  delinkType?: Maybe<Scalars['String']['output']>;
  linkType: Scalars['String']['output'];
  program?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
  subProgram?: Maybe<Scalars['String']['output']>;
};

export const GraphQLCommitmentType = {
  ChildSponsorship: 'ChildSponsorship',
  Correspondence: 'Correspondence',
  FundCommitment: 'FundCommitment',
  GiftCatalog: 'GiftCatalog',
  GiftCommitment: 'GiftCommitment',
  Intervention: 'Intervention',
  LivingSponsorship: 'LivingSponsorship',
  Na: 'NA'
} as const;

export type GraphQLCommitmentType = typeof GraphQLCommitmentType[keyof typeof GraphQLCommitmentType];
export type GraphQLContactPreference = {
  doNotCall?: Maybe<Scalars['Boolean']['output']>;
  doNotContact?: Maybe<Scalars['Boolean']['output']>;
  doNotEmail?: Maybe<Scalars['Boolean']['output']>;
  doNotMail?: Maybe<Scalars['Boolean']['output']>;
  doNotText?: Maybe<Scalars['Boolean']['output']>;
  emailInterestCategories?: Maybe<Array<Scalars['String']['output']>>;
  lastLoginDate?: Maybe<Scalars['AWSDateTime']['output']>;
  mailInterestCategories?: Maybe<Array<Scalars['String']['output']>>;
  phoneInterestCategories?: Maybe<Array<Scalars['String']['output']>>;
  subscriptionLists?: Maybe<Array<Scalars['String']['output']>>;
  textInterestCategories?: Maybe<Array<Scalars['String']['output']>>;
  undeliverableEmail?: Maybe<Scalars['Boolean']['output']>;
  undeliverablePhone?: Maybe<Scalars['Boolean']['output']>;
};

export type GraphQLContactVolunteer = {
  lastLogin?: Maybe<Scalars['AWSDateTime']['output']>;
  radius?: Maybe<Scalars['Int']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type GraphQLDeparture = {
  autoAcceptDate?: Maybe<Scalars['String']['output']>;
  departedChild: GraphQLDepartureChild;
  effectiveDate: Scalars['String']['output'];
  exitType: GraphQLDepartureExitType;
  replacementChild?: Maybe<GraphQLDepartureReplacementChild>;
  sub?: Maybe<GraphQLDepartureSub>;
};

export type GraphQLDepartureChild = {
  commitmentInternalId?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  globalId: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['AWSURL']['output']>;
};

export const GraphQLDepartureExitType = {
  Planned: 'planned',
  Unplanned: 'unplanned'
} as const;

export type GraphQLDepartureExitType = typeof GraphQLDepartureExitType[keyof typeof GraphQLDepartureExitType];
export type GraphQLDepartureReplacementChild = {
  globalId: Scalars['String']['output'];
  holdId: Scalars['String']['output'];
};

export type GraphQLDepartureSub = {
  child: GraphQLDepartureChild;
  completed: Scalars['Boolean']['output'];
  pendingCommitmentId: Scalars['String']['output'];
  shouldDisplay: Scalars['Boolean']['output'];
};

export type GraphQLDepartureSummary = {
  departures: Array<GraphQLDeparture>;
};

export type GraphQLGivingHistoryItem = {
  amount: Scalars['Float']['output'];
  beneficiaryGlobalId?: Maybe<Scalars['String']['output']>;
  beneficiaryPreferredName?: Maybe<Scalars['String']['output']>;
  commitmentFrequency: Scalars['String']['output'];
  commitmentId: Scalars['String']['output'];
  fundCode: Scalars['String']['output'];
  fundDescription: Scalars['String']['output'];
  fundIcon?: Maybe<Scalars['String']['output']>;
  givingType: Scalars['String']['output'];
  interventionId?: Maybe<Scalars['String']['output']>;
  isRefund: Scalars['Boolean']['output'];
  isTaxDeductible: Scalars['Boolean']['output'];
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  pledgeId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  receiptorId: Scalars['String']['output'];
  receiptorName: Scalars['String']['output'];
  recordDate: Scalars['String']['output'];
  recordId: Scalars['String']['output'];
  stockGiftInKindDescription?: Maybe<Scalars['String']['output']>;
  stockTickerSymbol?: Maybe<Scalars['String']['output']>;
  taxYear?: Maybe<Scalars['Int']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type GraphQLGivingTotals = {
  amountDue?: Maybe<Scalars['Float']['output']>;
  amountWaived?: Maybe<Scalars['Float']['output']>;
  annual?: Maybe<Scalars['Float']['output']>;
  monthly?: Maybe<Scalars['Float']['output']>;
  quarterly?: Maybe<Scalars['Float']['output']>;
  semiAnnual?: Maybe<Scalars['Float']['output']>;
  totalCreditRemaining?: Maybe<Scalars['Float']['output']>;
  totalDueThisMonthAmount?: Maybe<Scalars['Float']['output']>;
  totalMissedPaymentAmount?: Maybe<Scalars['Float']['output']>;
};

export type GraphQLLetter = {
  beneficiary?: Maybe<GraphQLLetterBeneficiary>;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  direction?: Maybe<GraphQLLetterDirection>;
  id: Scalars['String']['output'];
  isFinalLetter?: Maybe<Scalars['Boolean']['output']>;
  isReadBySupporter?: Maybe<Scalars['Boolean']['output']>;
  letterUrl?: Maybe<Scalars['AWSURL']['output']>;
  numberOfPages: Scalars['Int']['output'];
  pages: Array<GraphQLLetterPage>;
  readyDate?: Maybe<Scalars['AWSDateTime']['output']>;
  sourceLetterId?: Maybe<Scalars['String']['output']>;
  status: GraphQLLetterFriendlyStatus;
  supporter?: Maybe<GraphQLLetterSupporter>;
};

export type GraphQLLetterBeneficiary = {
  globalId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export const GraphQLLetterDirection = {
  B2S: 'B2S',
  S2B: 'S2B'
} as const;

export type GraphQLLetterDirection = typeof GraphQLLetterDirection[keyof typeof GraphQLLetterDirection];
export const GraphQLLetterFriendlyStatus = {
  Cancelled: 'CANCELLED',
  Complete: 'COMPLETE',
  HasAProblem: 'HAS_A_PROBLEM',
  InProcess: 'IN_PROCESS',
  InQualityAssurance: 'IN_QUALITY_ASSURANCE',
  InTranslation: 'IN_TRANSLATION',
  JustReceived: 'JUST_RECEIVED',
  ReadyForDelivery: 'READY_FOR_DELIVERY',
  Submitted: 'SUBMITTED',
  TranslationComplete: 'TRANSLATION_COMPLETE'
} as const;

export type GraphQLLetterFriendlyStatus = typeof GraphQLLetterFriendlyStatus[keyof typeof GraphQLLetterFriendlyStatus];
export type GraphQLLetterPage = {
  url?: Maybe<Scalars['AWSURL']['output']>;
};

export type GraphQLLetterSupporter = {
  globalId?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
};

export type GraphQLMutation = {
  primeSupporterCache?: Maybe<GraphQLSupporter>;
};


export type GraphQLMutationPrimeSupporterCacheArgs = {
  globalId: Scalars['String']['input'];
};

export type GraphQLPaymentMethodAch = {
  accountName: Scalars['String']['output'];
  lastFourOfAccountNumber: Scalars['String']['output'];
  routingNumber: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type GraphQLPaymentMethodBillingAddress = {
  attention?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type GraphQLPaymentMethodCreditCard = {
  cardType: Scalars['String']['output'];
  cardholderName: Scalars['String']['output'];
  digitalType?: Maybe<Scalars['String']['output']>;
  expirationDate: Scalars['String']['output'];
  expiryStatus?: Maybe<GraphQLCardExpiryStatus>;
  lastFour: Scalars['String']['output'];
  responseCode?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type GraphQLPledge = {
  endDate?: Maybe<Scalars['String']['output']>;
  lastInstallmentAmount?: Maybe<Scalars['Float']['output']>;
  lastInstallmentDate?: Maybe<Scalars['String']['output']>;
  nextInstallmentAmount?: Maybe<Scalars['Float']['output']>;
  nextInstallmentDate?: Maybe<Scalars['String']['output']>;
  outstandingAmount: Scalars['Float']['output'];
  pledgeId: Scalars['String']['output'];
  pledgeName: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  totalGivenToDate: Scalars['Float']['output'];
  totalPledgeAmount: Scalars['Float']['output'];
};

/**
 * Currently all types live here.
 * Originally the idea was to maintain separate sub-schemas with a custom script to merge them,
 * but until things mature it seemed best to keep it all in one file.
 *
 * TOC
 *
 * = Operations
 * = Scalars
 * = Supporter
 * = Payment & Billing
 * = Commitment
 */
export type GraphQLQuery = {
  supporter?: Maybe<GraphQLSupporter>;
};


/**
 * Currently all types live here.
 * Originally the idea was to maintain separate sub-schemas with a custom script to merge them,
 * but until things mature it seemed best to keep it all in one file.
 *
 * TOC
 *
 * = Operations
 * = Scalars
 * = Supporter
 * = Payment & Billing
 * = Commitment
 */
export type GraphQLQuerySupporterArgs = {
  globalId?: InputMaybe<Scalars['String']['input']>;
};

export type GraphQLRecentTransaction = {
  completedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  error?: Maybe<GraphQLRecentTransactionError>;
  lastUpdatedAt: Scalars['AWSDateTime']['output'];
  original: GraphQLRecentTransactionOriginal;
  status: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
};

export type GraphQLRecentTransactionError = {
  message?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['String']['output']>;
};

export type GraphQLRecentTransactionItem = {
  beneficiaryGlobalId?: Maybe<Scalars['String']['output']>;
  beneficiaryPhotoUrl?: Maybe<Scalars['String']['output']>;
  commitmentId?: Maybe<Scalars['String']['output']>;
  commitmentType: GraphQLCommitmentType;
  currentRate: Scalars['Float']['output'];
  frequency: Scalars['String']['output'];
  fundCode: Scalars['String']['output'];
  fundIcon?: Maybe<Scalars['String']['output']>;
  isRecurring: Scalars['Boolean']['output'];
};

export type GraphQLRecentTransactionOriginal = {
  cartId: Scalars['String']['output'];
  items: Array<GraphQLRecentTransactionItem>;
  requestedAt: Scalars['AWSDateTime']['output'];
};

export const GraphQLSponsorshipChangeState = {
  NoSub: 'NoSub',
  SubOffered: 'SubOffered',
  Transition: 'Transition'
} as const;

export type GraphQLSponsorshipChangeState = typeof GraphQLSponsorshipChangeState[keyof typeof GraphQLSponsorshipChangeState];
export type GraphQLSupporter = {
  addressDetails?: Maybe<GraphQLSupporterAddress>;
  commitments?: Maybe<Array<GraphQLCommitment>>;
  contacts?: Maybe<Array<GraphQLSupporterContact>>;
  correspondenceDeliveryPreference: Scalars['String']['output'];
  dataStatus: GraphQLSupporterDataStatus;
  departureSummary: GraphQLDepartureSummary;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  giftLimits?: Maybe<GraphQLSupporterGiftLimits>;
  givingTotals?: Maybe<GraphQLGivingTotals>;
  globalId: Scalars['String']['output'];
  internalId: Scalars['String']['output'];
  isGroup?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lettersAvailable?: Maybe<Array<GraphQLLetter>>;
  lettersInTransit?: Maybe<Array<GraphQLLetter>>;
  organizationName?: Maybe<Scalars['String']['output']>;
  paymentMethods?: Maybe<Array<GraphQLSupporterPaymentMethod>>;
  phone?: Maybe<Scalars['String']['output']>;
  pledges?: Maybe<Array<GraphQLPledge>>;
  preferredName?: Maybe<Scalars['String']['output']>;
  preferredUsername?: Maybe<Scalars['String']['output']>;
  primaryContactId: Scalars['String']['output'];
  primaryLanguage?: Maybe<Scalars['String']['output']>;
  rateChangeDeadline?: Maybe<Scalars['String']['output']>;
  rateChangeResponse?: Maybe<Scalars['String']['output']>;
  rateChangeSegment?: Maybe<Scalars['String']['output']>;
  recentGiving?: Maybe<Array<GraphQLGivingHistoryItem>>;
  recentTransactions?: Maybe<Array<GraphQLRecentTransaction>>;
  recordType?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  sourceCode?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  suffix?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  typeLevel2?: Maybe<Scalars['String']['output']>;
  typeLevel3?: Maybe<Scalars['String']['output']>;
  undeliverableEmail?: Maybe<Scalars['Boolean']['output']>;
  undeliverablePhone?: Maybe<Scalars['Boolean']['output']>;
  volunteerEvents?: Maybe<Array<GraphQLVolunteerEvent>>;
  writingPreferences?: Maybe<Array<GraphQLWritingPreference>>;
};

export type GraphQLSupporterAddress = {
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  isUndeliverable: Scalars['Boolean']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
};

export type GraphQLSupporterContact = {
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<GraphQLContactPreference>;
  preferredName?: Maybe<Scalars['String']['output']>;
  volunteer?: Maybe<GraphQLContactVolunteer>;
};

export type GraphQLSupporterDataIssue = {
  key: Scalars['String']['output'];
  lastAttemptAt?: Maybe<Scalars['AWSDateTime']['output']>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
  stale: Scalars['Boolean']['output'];
};

export type GraphQLSupporterDataStatus = {
  isPartial: Scalars['Boolean']['output'];
  issues: Array<GraphQLSupporterDataIssue>;
};

export type GraphQLSupporterGiftLimitGroup = {
  centerId?: Maybe<Scalars['String']['output']>;
  giftTypes: GraphQLSupporterGiftTypeLimits;
  id: Scalars['String']['output'];
};

export type GraphQLSupporterGiftLimitItem = {
  ineligibilityCode: Scalars['String']['output'];
  paymentOptions: GraphQLSupporterGiftPaymentOptions;
  paymentOptionsMinMax: GraphQLSupporterGiftPaymentOptionsMinMax;
  remainingAmount: Scalars['Float']['output'];
  remainingQuantity: Scalars['Float']['output'];
};

export type GraphQLSupporterGiftLimits = {
  children: Array<GraphQLSupporterGiftLimitGroup>;
  defaults: GraphQLSupporterGiftTypeLimits;
  projects: Array<GraphQLSupporterGiftLimitGroup>;
};

export type GraphQLSupporterGiftMinMaxAmount = {
  maxAmount: Scalars['Float']['output'];
  minAmount: Scalars['Float']['output'];
};

export type GraphQLSupporterGiftPaymentOptions = {
  annual: Scalars['Boolean']['output'];
  monthly: Scalars['Boolean']['output'];
  oneTime: Scalars['Boolean']['output'];
  quarterly: Scalars['Boolean']['output'];
  semiAnnual: Scalars['Boolean']['output'];
};

export type GraphQLSupporterGiftPaymentOptionsMinMax = {
  annual: GraphQLSupporterGiftMinMaxAmount;
  monthly: GraphQLSupporterGiftMinMaxAmount;
  oneTime: GraphQLSupporterGiftMinMaxAmount;
  quarterly: GraphQLSupporterGiftMinMaxAmount;
  semiAnnual: GraphQLSupporterGiftMinMaxAmount;
};

export type GraphQLSupporterGiftTypeLimits = {
  Birthday?: Maybe<GraphQLSupporterGiftLimitItem>;
  Center?: Maybe<GraphQLSupporterGiftLimitItem>;
  Child?: Maybe<GraphQLSupporterGiftLimitItem>;
  Family?: Maybe<GraphQLSupporterGiftLimitItem>;
  Final?: Maybe<GraphQLSupporterGiftLimitItem>;
};

export type GraphQLSupporterPaymentMethod = {
  accountNickname?: Maybe<Scalars['String']['output']>;
  ach?: Maybe<GraphQLPaymentMethodAch>;
  billingAddress?: Maybe<GraphQLPaymentMethodBillingAddress>;
  creditCard?: Maybe<GraphQLPaymentMethodCreditCard>;
  id?: Maybe<Scalars['String']['output']>;
  isCreatedForReceiptor?: Maybe<Scalars['Boolean']['output']>;
  isSavedForReuse?: Maybe<Scalars['Boolean']['output']>;
  paymentType: Scalars['String']['output'];
  sourceCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GraphQLVolunteerContact = {
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type GraphQLVolunteerEvent = {
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  slots: Array<GraphQLVolunteerSlot>;
  startDate: Scalars['String']['output'];
  venue?: Maybe<GraphQLVolunteerVenue>;
};

export type GraphQLVolunteerSlot = {
  contactId: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isWaiverComplete: Scalars['Boolean']['output'];
  shiftName?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
  status?: Maybe<GraphQLVolunteerStatus>;
};

export const GraphQLVolunteerStatus = {
  Approved: 'approved',
  Available: 'available',
  Canceled: 'canceled',
  Completed: 'completed',
  CompletedNoShow: 'completedNoShow',
  Confirmed: 'confirmed',
  Declined: 'declined',
  Pending: 'pending',
  Waitlist: 'waitlist'
} as const;

export type GraphQLVolunteerStatus = typeof GraphQLVolunteerStatus[keyof typeof GraphQLVolunteerStatus];
export type GraphQLVolunteerVenue = {
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export const GraphQLWritingPreference = {
  DigitalPrint: 'DigitalPrint',
  Electronic: 'Electronic'
} as const;

export type GraphQLWritingPreference = typeof GraphQLWritingPreference[keyof typeof GraphQLWritingPreference];


export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = Record<PropertyKey, never>, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;





/** Mapping between all available schema types and the resolvers types */
export type GraphQLResolversTypes = {
  AWSDate: ResolverTypeWrapper<Scalars['AWSDate']['output']>;
  AWSDateTime: ResolverTypeWrapper<Scalars['AWSDateTime']['output']>;
  AWSEmail: ResolverTypeWrapper<Scalars['AWSEmail']['output']>;
  AWSIPAddress: ResolverTypeWrapper<Scalars['AWSIPAddress']['output']>;
  AWSJSON: ResolverTypeWrapper<Scalars['AWSJSON']['output']>;
  AWSPhone: ResolverTypeWrapper<Scalars['AWSPhone']['output']>;
  AWSTime: ResolverTypeWrapper<Scalars['AWSTime']['output']>;
  AWSTimestamp: ResolverTypeWrapper<Scalars['AWSTimestamp']['output']>;
  AWSURL: ResolverTypeWrapper<Scalars['AWSURL']['output']>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  CardExpiryStatus: GraphQLCardExpiryStatus;
  Commitment: ResolverTypeWrapper<GraphQLCommitment>;
  CommitmentDates: ResolverTypeWrapper<GraphQLCommitmentDates>;
  CommitmentFund: ResolverTypeWrapper<GraphQLCommitmentFund>;
  CommitmentParticipant: ResolverTypeWrapper<GraphQLCommitmentParticipant>;
  CommitmentSys: ResolverTypeWrapper<GraphQLCommitmentSys>;
  CommitmentType: GraphQLCommitmentType;
  ContactPreference: ResolverTypeWrapper<GraphQLContactPreference>;
  ContactVolunteer: ResolverTypeWrapper<GraphQLContactVolunteer>;
  Departure: ResolverTypeWrapper<GraphQLDeparture>;
  DepartureChild: ResolverTypeWrapper<GraphQLDepartureChild>;
  DepartureExitType: GraphQLDepartureExitType;
  DepartureReplacementChild: ResolverTypeWrapper<GraphQLDepartureReplacementChild>;
  DepartureSub: ResolverTypeWrapper<GraphQLDepartureSub>;
  DepartureSummary: ResolverTypeWrapper<GraphQLDepartureSummary>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  GivingHistoryItem: ResolverTypeWrapper<GraphQLGivingHistoryItem>;
  GivingTotals: ResolverTypeWrapper<GraphQLGivingTotals>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  Letter: ResolverTypeWrapper<GraphQLLetter>;
  LetterBeneficiary: ResolverTypeWrapper<GraphQLLetterBeneficiary>;
  LetterDirection: GraphQLLetterDirection;
  LetterFriendlyStatus: GraphQLLetterFriendlyStatus;
  LetterPage: ResolverTypeWrapper<GraphQLLetterPage>;
  LetterSupporter: ResolverTypeWrapper<GraphQLLetterSupporter>;
  Mutation: ResolverTypeWrapper<Record<PropertyKey, never>>;
  PaymentMethodAch: ResolverTypeWrapper<GraphQLPaymentMethodAch>;
  PaymentMethodBillingAddress: ResolverTypeWrapper<GraphQLPaymentMethodBillingAddress>;
  PaymentMethodCreditCard: ResolverTypeWrapper<GraphQLPaymentMethodCreditCard>;
  Pledge: ResolverTypeWrapper<GraphQLPledge>;
  Query: ResolverTypeWrapper<Record<PropertyKey, never>>;
  RecentTransaction: ResolverTypeWrapper<GraphQLRecentTransaction>;
  RecentTransactionError: ResolverTypeWrapper<GraphQLRecentTransactionError>;
  RecentTransactionItem: ResolverTypeWrapper<GraphQLRecentTransactionItem>;
  RecentTransactionOriginal: ResolverTypeWrapper<GraphQLRecentTransactionOriginal>;
  SponsorshipChangeState: GraphQLSponsorshipChangeState;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Supporter: ResolverTypeWrapper<GraphQLSupporter>;
  SupporterAddress: ResolverTypeWrapper<GraphQLSupporterAddress>;
  SupporterContact: ResolverTypeWrapper<GraphQLSupporterContact>;
  SupporterDataIssue: ResolverTypeWrapper<GraphQLSupporterDataIssue>;
  SupporterDataStatus: ResolverTypeWrapper<GraphQLSupporterDataStatus>;
  SupporterGiftLimitGroup: ResolverTypeWrapper<GraphQLSupporterGiftLimitGroup>;
  SupporterGiftLimitItem: ResolverTypeWrapper<GraphQLSupporterGiftLimitItem>;
  SupporterGiftLimits: ResolverTypeWrapper<GraphQLSupporterGiftLimits>;
  SupporterGiftMinMaxAmount: ResolverTypeWrapper<GraphQLSupporterGiftMinMaxAmount>;
  SupporterGiftPaymentOptions: ResolverTypeWrapper<GraphQLSupporterGiftPaymentOptions>;
  SupporterGiftPaymentOptionsMinMax: ResolverTypeWrapper<GraphQLSupporterGiftPaymentOptionsMinMax>;
  SupporterGiftTypeLimits: ResolverTypeWrapper<GraphQLSupporterGiftTypeLimits>;
  SupporterPaymentMethod: ResolverTypeWrapper<GraphQLSupporterPaymentMethod>;
  VolunteerContact: ResolverTypeWrapper<GraphQLVolunteerContact>;
  VolunteerEvent: ResolverTypeWrapper<GraphQLVolunteerEvent>;
  VolunteerSlot: ResolverTypeWrapper<GraphQLVolunteerSlot>;
  VolunteerStatus: GraphQLVolunteerStatus;
  VolunteerVenue: ResolverTypeWrapper<GraphQLVolunteerVenue>;
  WritingPreference: GraphQLWritingPreference;
};

/** Mapping between all available schema types and the resolvers parents */
export type GraphQLResolversParentTypes = {
  AWSDate: Scalars['AWSDate']['output'];
  AWSDateTime: Scalars['AWSDateTime']['output'];
  AWSEmail: Scalars['AWSEmail']['output'];
  AWSIPAddress: Scalars['AWSIPAddress']['output'];
  AWSJSON: Scalars['AWSJSON']['output'];
  AWSPhone: Scalars['AWSPhone']['output'];
  AWSTime: Scalars['AWSTime']['output'];
  AWSTimestamp: Scalars['AWSTimestamp']['output'];
  AWSURL: Scalars['AWSURL']['output'];
  Boolean: Scalars['Boolean']['output'];
  Commitment: GraphQLCommitment;
  CommitmentDates: GraphQLCommitmentDates;
  CommitmentFund: GraphQLCommitmentFund;
  CommitmentParticipant: GraphQLCommitmentParticipant;
  CommitmentSys: GraphQLCommitmentSys;
  ContactPreference: GraphQLContactPreference;
  ContactVolunteer: GraphQLContactVolunteer;
  Departure: GraphQLDeparture;
  DepartureChild: GraphQLDepartureChild;
  DepartureReplacementChild: GraphQLDepartureReplacementChild;
  DepartureSub: GraphQLDepartureSub;
  DepartureSummary: GraphQLDepartureSummary;
  Float: Scalars['Float']['output'];
  GivingHistoryItem: GraphQLGivingHistoryItem;
  GivingTotals: GraphQLGivingTotals;
  ID: Scalars['ID']['output'];
  Int: Scalars['Int']['output'];
  Letter: GraphQLLetter;
  LetterBeneficiary: GraphQLLetterBeneficiary;
  LetterPage: GraphQLLetterPage;
  LetterSupporter: GraphQLLetterSupporter;
  Mutation: Record<PropertyKey, never>;
  PaymentMethodAch: GraphQLPaymentMethodAch;
  PaymentMethodBillingAddress: GraphQLPaymentMethodBillingAddress;
  PaymentMethodCreditCard: GraphQLPaymentMethodCreditCard;
  Pledge: GraphQLPledge;
  Query: Record<PropertyKey, never>;
  RecentTransaction: GraphQLRecentTransaction;
  RecentTransactionError: GraphQLRecentTransactionError;
  RecentTransactionItem: GraphQLRecentTransactionItem;
  RecentTransactionOriginal: GraphQLRecentTransactionOriginal;
  String: Scalars['String']['output'];
  Supporter: GraphQLSupporter;
  SupporterAddress: GraphQLSupporterAddress;
  SupporterContact: GraphQLSupporterContact;
  SupporterDataIssue: GraphQLSupporterDataIssue;
  SupporterDataStatus: GraphQLSupporterDataStatus;
  SupporterGiftLimitGroup: GraphQLSupporterGiftLimitGroup;
  SupporterGiftLimitItem: GraphQLSupporterGiftLimitItem;
  SupporterGiftLimits: GraphQLSupporterGiftLimits;
  SupporterGiftMinMaxAmount: GraphQLSupporterGiftMinMaxAmount;
  SupporterGiftPaymentOptions: GraphQLSupporterGiftPaymentOptions;
  SupporterGiftPaymentOptionsMinMax: GraphQLSupporterGiftPaymentOptionsMinMax;
  SupporterGiftTypeLimits: GraphQLSupporterGiftTypeLimits;
  SupporterPaymentMethod: GraphQLSupporterPaymentMethod;
  VolunteerContact: GraphQLVolunteerContact;
  VolunteerEvent: GraphQLVolunteerEvent;
  VolunteerSlot: GraphQLVolunteerSlot;
  VolunteerVenue: GraphQLVolunteerVenue;
};

export interface GraphQLAwsDateScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSDate'], any> {
  name: 'AWSDate';
}

export interface GraphQLAwsDateTimeScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSDateTime'], any> {
  name: 'AWSDateTime';
}

export interface GraphQLAwsEmailScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSEmail'], any> {
  name: 'AWSEmail';
}

export interface GraphQLAwsipAddressScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSIPAddress'], any> {
  name: 'AWSIPAddress';
}

export interface GraphQLAwsjsonScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSJSON'], any> {
  name: 'AWSJSON';
}

export interface GraphQLAwsPhoneScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSPhone'], any> {
  name: 'AWSPhone';
}

export interface GraphQLAwsTimeScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSTime'], any> {
  name: 'AWSTime';
}

export interface GraphQLAwsTimestampScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSTimestamp'], any> {
  name: 'AWSTimestamp';
}

export interface GraphQLAwsurlScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSURL'], any> {
  name: 'AWSURL';
}

export type GraphQLCommitmentResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['Commitment'] = GraphQLResolversParentTypes['Commitment']> = {
  _sys?: Resolver<Maybe<GraphQLResolversTypes['CommitmentSys']>, ParentType, ContextType>;
  amountDue?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  canGiveGifts?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
  canMakePayments?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
  canWrite?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
  commitmentType?: Resolver<GraphQLResolversTypes['CommitmentType'], ParentType, ContextType>;
  creditRemaining?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  dates?: Resolver<GraphQLResolversTypes['CommitmentDates'], ParentType, ContextType>;
  dueThisMonthAmount?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  frequency?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  fund?: Resolver<Maybe<GraphQLResolversTypes['CommitmentFund']>, ParentType, ContextType>;
  globalId?: Resolver<GraphQLResolversTypes['ID'], ParentType, ContextType>;
  hasCredit?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  hasDueThisMonth?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  hasMissedPayment?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  internalId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  interventionId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  isCorrespondent?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  isRecurring?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
  lastCorrespondenceDate?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  missedPaymentAmount?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  participant?: Resolver<Maybe<GraphQLResolversTypes['CommitmentParticipant']>, ParentType, ContextType>;
  paymentDateNext?: Resolver<Maybe<GraphQLResolversTypes['AWSDate']>, ParentType, ContextType>;
  paymentDatePending?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  paymentFrequency?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  paymentMethodId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  paymentPullDay?: Resolver<Maybe<GraphQLResolversTypes['Int']>, ParentType, ContextType>;
  rate?: Resolver<GraphQLResolversTypes['Float'], ParentType, ContextType>;
  receiptorId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  sourceCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  sponsorshipChangeState?: Resolver<Maybe<GraphQLResolversTypes['SponsorshipChangeState']>, ParentType, ContextType>;
  status?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
};

export type GraphQLCommitmentDatesResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['CommitmentDates'] = GraphQLResolversParentTypes['CommitmentDates']> = {
  end?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
};

export type GraphQLCommitmentFundResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['CommitmentFund'] = GraphQLResolversParentTypes['CommitmentFund']> = {
  code?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
};

export type GraphQLCommitmentParticipantResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['CommitmentParticipant'] = GraphQLResolversParentTypes['CommitmentParticipant']> = {
  birthdate?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  gender?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  globalId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  localId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  photoUrl?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
};

export type GraphQLCommitmentSysResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['CommitmentSys'] = GraphQLResolversParentTypes['CommitmentSys']> = {
  billingType?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  delinkType?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  linkType?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  program?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  recordType?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  subProgram?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
};

export type GraphQLContactPreferenceResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['ContactPreference'] = GraphQLResolversParentTypes['ContactPreference']> = {
  doNotCall?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  doNotContact?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  doNotEmail?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  doNotMail?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  doNotText?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  emailInterestCategories?: Resolver<Maybe<Array<GraphQLResolversTypes['String']>>, ParentType, ContextType>;
  lastLoginDate?: Resolver<Maybe<GraphQLResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  mailInterestCategories?: Resolver<Maybe<Array<GraphQLResolversTypes['String']>>, ParentType, ContextType>;
  phoneInterestCategories?: Resolver<Maybe<Array<GraphQLResolversTypes['String']>>, ParentType, ContextType>;
  subscriptionLists?: Resolver<Maybe<Array<GraphQLResolversTypes['String']>>, ParentType, ContextType>;
  textInterestCategories?: Resolver<Maybe<Array<GraphQLResolversTypes['String']>>, ParentType, ContextType>;
  undeliverableEmail?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  undeliverablePhone?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type GraphQLContactVolunteerResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['ContactVolunteer'] = GraphQLResolversParentTypes['ContactVolunteer']> = {
  lastLogin?: Resolver<Maybe<GraphQLResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  radius?: Resolver<Maybe<GraphQLResolversTypes['Int']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
};

export type GraphQLDepartureResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['Departure'] = GraphQLResolversParentTypes['Departure']> = {
  autoAcceptDate?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  departedChild?: Resolver<GraphQLResolversTypes['DepartureChild'], ParentType, ContextType>;
  effectiveDate?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  exitType?: Resolver<GraphQLResolversTypes['DepartureExitType'], ParentType, ContextType>;
  replacementChild?: Resolver<Maybe<GraphQLResolversTypes['DepartureReplacementChild']>, ParentType, ContextType>;
  sub?: Resolver<Maybe<GraphQLResolversTypes['DepartureSub']>, ParentType, ContextType>;
};

export type GraphQLDepartureChildResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['DepartureChild'] = GraphQLResolversParentTypes['DepartureChild']> = {
  commitmentInternalId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  globalId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<GraphQLResolversTypes['AWSURL']>, ParentType, ContextType>;
};

export type GraphQLDepartureReplacementChildResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['DepartureReplacementChild'] = GraphQLResolversParentTypes['DepartureReplacementChild']> = {
  globalId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  holdId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
};

export type GraphQLDepartureSubResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['DepartureSub'] = GraphQLResolversParentTypes['DepartureSub']> = {
  child?: Resolver<GraphQLResolversTypes['DepartureChild'], ParentType, ContextType>;
  completed?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
  pendingCommitmentId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  shouldDisplay?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
};

export type GraphQLDepartureSummaryResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['DepartureSummary'] = GraphQLResolversParentTypes['DepartureSummary']> = {
  departures?: Resolver<Array<GraphQLResolversTypes['Departure']>, ParentType, ContextType>;
};

export type GraphQLGivingHistoryItemResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['GivingHistoryItem'] = GraphQLResolversParentTypes['GivingHistoryItem']> = {
  amount?: Resolver<GraphQLResolversTypes['Float'], ParentType, ContextType>;
  beneficiaryGlobalId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  beneficiaryPreferredName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  commitmentFrequency?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  commitmentId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  fundCode?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  fundDescription?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  fundIcon?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  givingType?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  interventionId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  isRefund?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
  isTaxDeductible?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
  paymentMethodId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  pledgeId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<GraphQLResolversTypes['Int']>, ParentType, ContextType>;
  receiptorId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  receiptorName?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  recordDate?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  recordId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  stockGiftInKindDescription?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  stockTickerSymbol?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  taxYear?: Resolver<Maybe<GraphQLResolversTypes['Int']>, ParentType, ContextType>;
  transactionId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
};

export type GraphQLGivingTotalsResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['GivingTotals'] = GraphQLResolversParentTypes['GivingTotals']> = {
  amountDue?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  amountWaived?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  annual?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  monthly?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  quarterly?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  semiAnnual?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  totalCreditRemaining?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  totalDueThisMonthAmount?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  totalMissedPaymentAmount?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
};

export type GraphQLLetterResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['Letter'] = GraphQLResolversParentTypes['Letter']> = {
  beneficiary?: Resolver<Maybe<GraphQLResolversTypes['LetterBeneficiary']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<GraphQLResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  direction?: Resolver<Maybe<GraphQLResolversTypes['LetterDirection']>, ParentType, ContextType>;
  id?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  isFinalLetter?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  isReadBySupporter?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  letterUrl?: Resolver<Maybe<GraphQLResolversTypes['AWSURL']>, ParentType, ContextType>;
  numberOfPages?: Resolver<GraphQLResolversTypes['Int'], ParentType, ContextType>;
  pages?: Resolver<Array<GraphQLResolversTypes['LetterPage']>, ParentType, ContextType>;
  readyDate?: Resolver<Maybe<GraphQLResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  sourceLetterId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<GraphQLResolversTypes['LetterFriendlyStatus'], ParentType, ContextType>;
  supporter?: Resolver<Maybe<GraphQLResolversTypes['LetterSupporter']>, ParentType, ContextType>;
};

export type GraphQLLetterBeneficiaryResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['LetterBeneficiary'] = GraphQLResolversParentTypes['LetterBeneficiary']> = {
  globalId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
};

export type GraphQLLetterPageResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['LetterPage'] = GraphQLResolversParentTypes['LetterPage']> = {
  url?: Resolver<Maybe<GraphQLResolversTypes['AWSURL']>, ParentType, ContextType>;
};

export type GraphQLLetterSupporterResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['LetterSupporter'] = GraphQLResolversParentTypes['LetterSupporter']> = {
  globalId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  preferredName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
};

export type GraphQLMutationResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['Mutation'] = GraphQLResolversParentTypes['Mutation']> = {
  primeSupporterCache?: Resolver<Maybe<GraphQLResolversTypes['Supporter']>, ParentType, ContextType, RequireFields<GraphQLMutationPrimeSupporterCacheArgs, 'globalId'>>;
};

export type GraphQLPaymentMethodAchResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['PaymentMethodAch'] = GraphQLResolversParentTypes['PaymentMethodAch']> = {
  accountName?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  lastFourOfAccountNumber?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  routingNumber?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  token?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
};

export type GraphQLPaymentMethodBillingAddressResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['PaymentMethodBillingAddress'] = GraphQLResolversParentTypes['PaymentMethodBillingAddress']> = {
  attention?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  stateCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
};

export type GraphQLPaymentMethodCreditCardResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['PaymentMethodCreditCard'] = GraphQLResolversParentTypes['PaymentMethodCreditCard']> = {
  cardType?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  cardholderName?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  digitalType?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  expirationDate?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  expiryStatus?: Resolver<Maybe<GraphQLResolversTypes['CardExpiryStatus']>, ParentType, ContextType>;
  lastFour?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  responseCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
};

export type GraphQLPledgeResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['Pledge'] = GraphQLResolversParentTypes['Pledge']> = {
  endDate?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  lastInstallmentAmount?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  lastInstallmentDate?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  nextInstallmentAmount?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  nextInstallmentDate?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  outstandingAmount?: Resolver<GraphQLResolversTypes['Float'], ParentType, ContextType>;
  pledgeId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  pledgeName?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  totalGivenToDate?: Resolver<GraphQLResolversTypes['Float'], ParentType, ContextType>;
  totalPledgeAmount?: Resolver<GraphQLResolversTypes['Float'], ParentType, ContextType>;
};

export type GraphQLQueryResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['Query'] = GraphQLResolversParentTypes['Query']> = {
  supporter?: Resolver<Maybe<GraphQLResolversTypes['Supporter']>, ParentType, ContextType, Partial<GraphQLQuerySupporterArgs>>;
};

export type GraphQLRecentTransactionResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['RecentTransaction'] = GraphQLResolversParentTypes['RecentTransaction']> = {
  completedAt?: Resolver<Maybe<GraphQLResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<GraphQLResolversTypes['AWSDateTime'], ParentType, ContextType>;
  error?: Resolver<Maybe<GraphQLResolversTypes['RecentTransactionError']>, ParentType, ContextType>;
  lastUpdatedAt?: Resolver<GraphQLResolversTypes['AWSDateTime'], ParentType, ContextType>;
  original?: Resolver<GraphQLResolversTypes['RecentTransactionOriginal'], ParentType, ContextType>;
  status?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
};

export type GraphQLRecentTransactionErrorResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['RecentTransactionError'] = GraphQLResolversParentTypes['RecentTransactionError']> = {
  message?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  step?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
};

export type GraphQLRecentTransactionItemResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['RecentTransactionItem'] = GraphQLResolversParentTypes['RecentTransactionItem']> = {
  beneficiaryGlobalId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  beneficiaryPhotoUrl?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  commitmentId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  commitmentType?: Resolver<GraphQLResolversTypes['CommitmentType'], ParentType, ContextType>;
  currentRate?: Resolver<GraphQLResolversTypes['Float'], ParentType, ContextType>;
  frequency?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  fundCode?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  fundIcon?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  isRecurring?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
};

export type GraphQLRecentTransactionOriginalResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['RecentTransactionOriginal'] = GraphQLResolversParentTypes['RecentTransactionOriginal']> = {
  cartId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  items?: Resolver<Array<GraphQLResolversTypes['RecentTransactionItem']>, ParentType, ContextType>;
  requestedAt?: Resolver<GraphQLResolversTypes['AWSDateTime'], ParentType, ContextType>;
};

export type GraphQLSupporterResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['Supporter'] = GraphQLResolversParentTypes['Supporter']> = {
  addressDetails?: Resolver<Maybe<GraphQLResolversTypes['SupporterAddress']>, ParentType, ContextType>;
  commitments?: Resolver<Maybe<Array<GraphQLResolversTypes['Commitment']>>, ParentType, ContextType>;
  contacts?: Resolver<Maybe<Array<GraphQLResolversTypes['SupporterContact']>>, ParentType, ContextType>;
  correspondenceDeliveryPreference?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  dataStatus?: Resolver<GraphQLResolversTypes['SupporterDataStatus'], ParentType, ContextType>;
  departureSummary?: Resolver<GraphQLResolversTypes['DepartureSummary'], ParentType, ContextType>;
  displayName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  gender?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  giftLimits?: Resolver<Maybe<GraphQLResolversTypes['SupporterGiftLimits']>, ParentType, ContextType>;
  givingTotals?: Resolver<Maybe<GraphQLResolversTypes['GivingTotals']>, ParentType, ContextType>;
  globalId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  internalId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  isGroup?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  lettersAvailable?: Resolver<Maybe<Array<GraphQLResolversTypes['Letter']>>, ParentType, ContextType>;
  lettersInTransit?: Resolver<Maybe<Array<GraphQLResolversTypes['Letter']>>, ParentType, ContextType>;
  organizationName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  paymentMethods?: Resolver<Maybe<Array<GraphQLResolversTypes['SupporterPaymentMethod']>>, ParentType, ContextType>;
  phone?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  pledges?: Resolver<Maybe<Array<GraphQLResolversTypes['Pledge']>>, ParentType, ContextType>;
  preferredName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  preferredUsername?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  primaryContactId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  primaryLanguage?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  rateChangeDeadline?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  rateChangeResponse?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  rateChangeSegment?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  recentGiving?: Resolver<Maybe<Array<GraphQLResolversTypes['GivingHistoryItem']>>, ParentType, ContextType>;
  recentTransactions?: Resolver<Maybe<Array<GraphQLResolversTypes['RecentTransaction']>>, ParentType, ContextType>;
  recordType?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  salutation?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  sourceCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  suffix?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  typeLevel2?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  typeLevel3?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  undeliverableEmail?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  undeliverablePhone?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  volunteerEvents?: Resolver<Maybe<Array<GraphQLResolversTypes['VolunteerEvent']>>, ParentType, ContextType>;
  writingPreferences?: Resolver<Maybe<Array<GraphQLResolversTypes['WritingPreference']>>, ParentType, ContextType>;
};

export type GraphQLSupporterAddressResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterAddress'] = GraphQLResolversParentTypes['SupporterAddress']> = {
  city?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  isUndeliverable?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
  postalCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  street2?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
};

export type GraphQLSupporterContactResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterContact'] = GraphQLResolversParentTypes['SupporterContact']> = {
  email?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  isPrimary?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  preferences?: Resolver<Maybe<GraphQLResolversTypes['ContactPreference']>, ParentType, ContextType>;
  preferredName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  volunteer?: Resolver<Maybe<GraphQLResolversTypes['ContactVolunteer']>, ParentType, ContextType>;
};

export type GraphQLSupporterDataIssueResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterDataIssue'] = GraphQLResolversParentTypes['SupporterDataIssue']> = {
  key?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  lastAttemptAt?: Resolver<Maybe<GraphQLResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  message?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  retryable?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
  stale?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
};

export type GraphQLSupporterDataStatusResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterDataStatus'] = GraphQLResolversParentTypes['SupporterDataStatus']> = {
  isPartial?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
  issues?: Resolver<Array<GraphQLResolversTypes['SupporterDataIssue']>, ParentType, ContextType>;
};

export type GraphQLSupporterGiftLimitGroupResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterGiftLimitGroup'] = GraphQLResolversParentTypes['SupporterGiftLimitGroup']> = {
  centerId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  giftTypes?: Resolver<GraphQLResolversTypes['SupporterGiftTypeLimits'], ParentType, ContextType>;
  id?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
};

export type GraphQLSupporterGiftLimitItemResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterGiftLimitItem'] = GraphQLResolversParentTypes['SupporterGiftLimitItem']> = {
  ineligibilityCode?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  paymentOptions?: Resolver<GraphQLResolversTypes['SupporterGiftPaymentOptions'], ParentType, ContextType>;
  paymentOptionsMinMax?: Resolver<GraphQLResolversTypes['SupporterGiftPaymentOptionsMinMax'], ParentType, ContextType>;
  remainingAmount?: Resolver<GraphQLResolversTypes['Float'], ParentType, ContextType>;
  remainingQuantity?: Resolver<GraphQLResolversTypes['Float'], ParentType, ContextType>;
};

export type GraphQLSupporterGiftLimitsResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterGiftLimits'] = GraphQLResolversParentTypes['SupporterGiftLimits']> = {
  children?: Resolver<Array<GraphQLResolversTypes['SupporterGiftLimitGroup']>, ParentType, ContextType>;
  defaults?: Resolver<GraphQLResolversTypes['SupporterGiftTypeLimits'], ParentType, ContextType>;
  projects?: Resolver<Array<GraphQLResolversTypes['SupporterGiftLimitGroup']>, ParentType, ContextType>;
};

export type GraphQLSupporterGiftMinMaxAmountResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterGiftMinMaxAmount'] = GraphQLResolversParentTypes['SupporterGiftMinMaxAmount']> = {
  maxAmount?: Resolver<GraphQLResolversTypes['Float'], ParentType, ContextType>;
  minAmount?: Resolver<GraphQLResolversTypes['Float'], ParentType, ContextType>;
};

export type GraphQLSupporterGiftPaymentOptionsResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterGiftPaymentOptions'] = GraphQLResolversParentTypes['SupporterGiftPaymentOptions']> = {
  annual?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
  monthly?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
  oneTime?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
  quarterly?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
  semiAnnual?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
};

export type GraphQLSupporterGiftPaymentOptionsMinMaxResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterGiftPaymentOptionsMinMax'] = GraphQLResolversParentTypes['SupporterGiftPaymentOptionsMinMax']> = {
  annual?: Resolver<GraphQLResolversTypes['SupporterGiftMinMaxAmount'], ParentType, ContextType>;
  monthly?: Resolver<GraphQLResolversTypes['SupporterGiftMinMaxAmount'], ParentType, ContextType>;
  oneTime?: Resolver<GraphQLResolversTypes['SupporterGiftMinMaxAmount'], ParentType, ContextType>;
  quarterly?: Resolver<GraphQLResolversTypes['SupporterGiftMinMaxAmount'], ParentType, ContextType>;
  semiAnnual?: Resolver<GraphQLResolversTypes['SupporterGiftMinMaxAmount'], ParentType, ContextType>;
};

export type GraphQLSupporterGiftTypeLimitsResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterGiftTypeLimits'] = GraphQLResolversParentTypes['SupporterGiftTypeLimits']> = {
  Birthday?: Resolver<Maybe<GraphQLResolversTypes['SupporterGiftLimitItem']>, ParentType, ContextType>;
  Center?: Resolver<Maybe<GraphQLResolversTypes['SupporterGiftLimitItem']>, ParentType, ContextType>;
  Child?: Resolver<Maybe<GraphQLResolversTypes['SupporterGiftLimitItem']>, ParentType, ContextType>;
  Family?: Resolver<Maybe<GraphQLResolversTypes['SupporterGiftLimitItem']>, ParentType, ContextType>;
  Final?: Resolver<Maybe<GraphQLResolversTypes['SupporterGiftLimitItem']>, ParentType, ContextType>;
};

export type GraphQLSupporterPaymentMethodResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterPaymentMethod'] = GraphQLResolversParentTypes['SupporterPaymentMethod']> = {
  accountNickname?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  ach?: Resolver<Maybe<GraphQLResolversTypes['PaymentMethodAch']>, ParentType, ContextType>;
  billingAddress?: Resolver<Maybe<GraphQLResolversTypes['PaymentMethodBillingAddress']>, ParentType, ContextType>;
  creditCard?: Resolver<Maybe<GraphQLResolversTypes['PaymentMethodCreditCard']>, ParentType, ContextType>;
  id?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  isCreatedForReceiptor?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  isSavedForReuse?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  paymentType?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  sourceCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
};

export type GraphQLVolunteerContactResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['VolunteerContact'] = GraphQLResolversParentTypes['VolunteerContact']> = {
  email?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  fullName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
};

export type GraphQLVolunteerEventResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['VolunteerEvent'] = GraphQLResolversParentTypes['VolunteerEvent']> = {
  description?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  locationName?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  slots?: Resolver<Array<GraphQLResolversTypes['VolunteerSlot']>, ParentType, ContextType>;
  startDate?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  venue?: Resolver<Maybe<GraphQLResolversTypes['VolunteerVenue']>, ParentType, ContextType>;
};

export type GraphQLVolunteerSlotResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['VolunteerSlot'] = GraphQLResolversParentTypes['VolunteerSlot']> = {
  contactId?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  endDate?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  isWaiverComplete?: Resolver<GraphQLResolversTypes['Boolean'], ParentType, ContextType>;
  shiftName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<GraphQLResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<Maybe<GraphQLResolversTypes['VolunteerStatus']>, ParentType, ContextType>;
};

export type GraphQLVolunteerVenueResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['VolunteerVenue'] = GraphQLResolversParentTypes['VolunteerVenue']> = {
  address1?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  address2?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
};

export type GraphQLResolvers<ContextType = any> = {
  AWSDate?: GraphQLScalarType;
  AWSDateTime?: GraphQLScalarType;
  AWSEmail?: GraphQLScalarType;
  AWSIPAddress?: GraphQLScalarType;
  AWSJSON?: GraphQLScalarType;
  AWSPhone?: GraphQLScalarType;
  AWSTime?: GraphQLScalarType;
  AWSTimestamp?: GraphQLScalarType;
  AWSURL?: GraphQLScalarType;
  Commitment?: GraphQLCommitmentResolvers<ContextType>;
  CommitmentDates?: GraphQLCommitmentDatesResolvers<ContextType>;
  CommitmentFund?: GraphQLCommitmentFundResolvers<ContextType>;
  CommitmentParticipant?: GraphQLCommitmentParticipantResolvers<ContextType>;
  CommitmentSys?: GraphQLCommitmentSysResolvers<ContextType>;
  ContactPreference?: GraphQLContactPreferenceResolvers<ContextType>;
  ContactVolunteer?: GraphQLContactVolunteerResolvers<ContextType>;
  Departure?: GraphQLDepartureResolvers<ContextType>;
  DepartureChild?: GraphQLDepartureChildResolvers<ContextType>;
  DepartureReplacementChild?: GraphQLDepartureReplacementChildResolvers<ContextType>;
  DepartureSub?: GraphQLDepartureSubResolvers<ContextType>;
  DepartureSummary?: GraphQLDepartureSummaryResolvers<ContextType>;
  GivingHistoryItem?: GraphQLGivingHistoryItemResolvers<ContextType>;
  GivingTotals?: GraphQLGivingTotalsResolvers<ContextType>;
  Letter?: GraphQLLetterResolvers<ContextType>;
  LetterBeneficiary?: GraphQLLetterBeneficiaryResolvers<ContextType>;
  LetterPage?: GraphQLLetterPageResolvers<ContextType>;
  LetterSupporter?: GraphQLLetterSupporterResolvers<ContextType>;
  Mutation?: GraphQLMutationResolvers<ContextType>;
  PaymentMethodAch?: GraphQLPaymentMethodAchResolvers<ContextType>;
  PaymentMethodBillingAddress?: GraphQLPaymentMethodBillingAddressResolvers<ContextType>;
  PaymentMethodCreditCard?: GraphQLPaymentMethodCreditCardResolvers<ContextType>;
  Pledge?: GraphQLPledgeResolvers<ContextType>;
  Query?: GraphQLQueryResolvers<ContextType>;
  RecentTransaction?: GraphQLRecentTransactionResolvers<ContextType>;
  RecentTransactionError?: GraphQLRecentTransactionErrorResolvers<ContextType>;
  RecentTransactionItem?: GraphQLRecentTransactionItemResolvers<ContextType>;
  RecentTransactionOriginal?: GraphQLRecentTransactionOriginalResolvers<ContextType>;
  Supporter?: GraphQLSupporterResolvers<ContextType>;
  SupporterAddress?: GraphQLSupporterAddressResolvers<ContextType>;
  SupporterContact?: GraphQLSupporterContactResolvers<ContextType>;
  SupporterDataIssue?: GraphQLSupporterDataIssueResolvers<ContextType>;
  SupporterDataStatus?: GraphQLSupporterDataStatusResolvers<ContextType>;
  SupporterGiftLimitGroup?: GraphQLSupporterGiftLimitGroupResolvers<ContextType>;
  SupporterGiftLimitItem?: GraphQLSupporterGiftLimitItemResolvers<ContextType>;
  SupporterGiftLimits?: GraphQLSupporterGiftLimitsResolvers<ContextType>;
  SupporterGiftMinMaxAmount?: GraphQLSupporterGiftMinMaxAmountResolvers<ContextType>;
  SupporterGiftPaymentOptions?: GraphQLSupporterGiftPaymentOptionsResolvers<ContextType>;
  SupporterGiftPaymentOptionsMinMax?: GraphQLSupporterGiftPaymentOptionsMinMaxResolvers<ContextType>;
  SupporterGiftTypeLimits?: GraphQLSupporterGiftTypeLimitsResolvers<ContextType>;
  SupporterPaymentMethod?: GraphQLSupporterPaymentMethodResolvers<ContextType>;
  VolunteerContact?: GraphQLVolunteerContactResolvers<ContextType>;
  VolunteerEvent?: GraphQLVolunteerEventResolvers<ContextType>;
  VolunteerSlot?: GraphQLVolunteerSlotResolvers<ContextType>;
  VolunteerVenue?: GraphQLVolunteerVenueResolvers<ContextType>;
};

